define(['angular', 'angular-resource'], function (angular) {
    return angular
        .module('debugServices', ['ngResource', 'settingsModels'])
        .factory('Debug', [
            '$http',
            function ($http) {
                return {
                    log: function (message) {
                        $http.post(Routing.generate('log_debug'), message);
                    },
                };
            },
        ]);
});
